define.alias("shared/components/shared/restricted-area/modal", "preview-grid/components/shared/restricted-area/modal");